import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContactAndAddressService } from '@services/contact-and-address/contact-and-address.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { TranslateService } from '@services/translate/translate.service';

@Component({
    selector: 'select-contact-dialog',
    templateUrl: './select-contact-dialog.component.html',
    styleUrls: ['./select-contact-dialog.component.scss'],
    providers: [ContactAndAddressService],
    standalone: false
})
export class SelectContactDialogComponent implements OnInit {

  query: any;
  columns = [{ prop: 'title' }];
  contactTranslation: any;
  contactAndAddress: any = [];
  defContactAndAddress: any = [];
  sortType = 'none';
  selectedItemId: any;

  constructor(
      public dialogRef: MatDialogRef<SelectContactDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private ms: MessengerService,
      public contactAndAddressService: ContactAndAddressService, private ts: TranslateService
  ) {
    this.query = { OwnerOrganisationID: this.ms.getOrganisation().OrganisationID, type: this.data.type };
  }

  async ngOnInit() {
    this.contactTranslation = this.ts.get('contact');
    this.contactAndAddressService.find(0, 100000, this.query).then(result => {
      if (result?.data) {
        this.contactAndAddress = result.data;
        this.defContactAndAddress = JSON.parse(JSON.stringify((this.contactAndAddress)));
      }
    })
  }

  select() {
    this.dialogRef.close(this.defContactAndAddress.find(el => el._id === this.selectedItemId));
  }

  sort() {
    if (this.sortType === 'none') {
      this.sortType = 'up';
    } else if (this.sortType === 'up') {
      this.sortType = 'down';
    } else if (this.sortType === 'down') {
      this.sortType = 'none';
    }
    if (this.sortType !== 'none') {
      const searchField = 'title';
      this.contactAndAddress = this.contactAndAddress.sort((a, b) => {
        if (a[searchField].toLowerCase() < b[searchField].toLowerCase()) {
          return this.sortType === 'up' ? -1 : 1;
        }
        if (a[searchField].toLowerCase() > b[searchField].toLowerCase()) {
          return this.sortType === 'up' ? 1 : -1;
        }
        return 0;
      })
    } else {
      this.contactAndAddress = JSON.parse(JSON.stringify((this.defContactAndAddress)));
    }
  }
}
